import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=707031dc&functional=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707031dc')) {
      api.createRecord('707031dc', component.options)
    } else {
      api.rerender('707031dc', component.options)
    }
    module.hot.accept("./Btn.vue?vue&type=template&id=707031dc&functional=true", function () {
      api.rerender('707031dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/Btn.vue"
export default component.exports